import type React from "react";
import "./MatchWordsWithPicturesActivity.scss";
import { Fireworks } from "../../../shared/components/Fireworks/Fireworks";
import { formClass } from "../../../shared/helpers";
import { DraggableElement } from "./DraggableElement";
import { DroppableElement } from "./DroppableElement";
import ToolBar from "./ToolBar";
import useMatchPicturesWithWords from "./useResetCardsAndWordsToDrop";

type Props = {
	activity: { word: string; imageUrl: string }[];
	activityId: string;
};

const MatchWordsWithPicturesActivity: React.FC<Props> = ({
	activity,
	activityId,
}) => {
	const {
		cards,
		setCards,
		wordsToDrop,
		setWordsToDrop,
		checkAnswer,
		reset,
		fireworksTrigger,
		setFireworksTrigger,
	} = useMatchPicturesWithWords(activity, activityId);

	const handleDropWord = (
		card: { card: { word: string; index: number; id: string } },
		cardIndex: number,
	) => {
		const newCards = [...cards];
		newCards[cardIndex] = {
			...newCards[cardIndex],
			word: card.card.word,
			currentIndex: cardIndex,
			imageUrl: newCards[cardIndex].imageUrl,
			originalIndex: card.card.index,
		};

		setCards(newCards);

		const newWordsToDrop = wordsToDrop.map((wordCard) => {
			if (wordCard.index === card.card.index) {
				return {
					...wordCard,
					word: "",
				};
			}
			return wordCard;
		});

		setWordsToDrop(newWordsToDrop);
	};

	const handleWordClick = (
		word: string,
		currentIndex: number,
		originalIndex: number,
	) => {
		const newCards = [...cards];
		newCards[currentIndex].word = "";
		newCards[currentIndex].correct = undefined;
		setCards(newCards);

		const newWordsToDrop = [...wordsToDrop];
		newWordsToDrop[originalIndex] = {
			...newWordsToDrop[originalIndex],
			word,
		};
		setWordsToDrop(newWordsToDrop);
	};

	const handleFireworksComplete = () => {
		setFireworksTrigger(false);
	};

	return (
		<div className={formClass("container")}>
			{fireworksTrigger && (
				<Fireworks
					trigger={fireworksTrigger}
					onComplete={handleFireworksComplete}
				/>
			)}
			<ToolBar
				activityId={activityId}
				checkAnswer={checkAnswer}
				reset={reset}
			/>
			<div className="container__words-to-drop">
				{wordsToDrop.map((card) => (
					<DraggableElement key={card.id} card={card} />
				))}
			</div>
			<div className="container__cards">
				{cards?.map((card, index) => (
					<DroppableElement
						onWordClick={handleWordClick}
						onDropWord={handleDropWord}
						key={card.id}
						card={card}
						index={index}
					/>
				))}
			</div>
		</div>
	);
};

export default MatchWordsWithPicturesActivity;
